// extracted by mini-css-extract-plugin
export default {"tag-nursing-complexity":"tags_tag-nursing-complexity__7PR29"};